export default class QueryString {
  static PAGE_NAME_QUERY_STRING = 'page';
  static PAGE_SIZE_NAME_QUERY_STRING = 'pageSize';
}
